// Checks if a value is either 0 or 1
export const isBinary=a=>[0,1].includes(a);/**
 * Converts binary string ("0"/"1"), boolean string ( "true"/"false"), and pure boolean values (true/false) to int binary, falls back to a supplied default value;
 *
 * @param value
 * @param default_value
 * @returns {number|*}
 *
 * @example
 *  parseBinary("1", 0);  // Returns 1
 *  parseBinary("true", 0);  // Returns 1
 *  parseBinary(true, 0);  // Returns 1
 *  parseBinary("not a binary", 0)  // returns 0
 */export const parseBinary=(a,b=0)=>[0,1].includes(parseInt(a))?parseInt(a):["true","false"].includes(a)?"true"===a?1:0:[!0,!1].includes(a)?!0===a?1:0:b;export default{isBinary,parseBinary};